import "./SeniorAidPortal.module.css";
import SiteHeader from "@/reusable_sections/Header";
import AidSubmissionForm from "./sections/AidSubmissionForm";
import OurCommitmentToPrivacy from "./sections/OurCommitmentToPrivacy";
import StSampsonFooter from "@/reusable_sections/Footer";
export default function SeniorAidPortalPage() {
  return <div>
      <SiteHeader />
      <AidSubmissionForm />
      <OurCommitmentToPrivacy />
      <StSampsonFooter />
    </div>;
}